<template>
  <div class="emptyModule">
   <slot></slot>
  </div>
</template>

<script>
export default {
    name:'emptyModule',

}
</script>

<style lang="less">
.emptyModule {
  width: 622px;
  margin: 0 auto;
  box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.2);
  background: #FFFFFF;
  border-radius: 8px;
  padding-bottom: 24px;
  display: flex;
  flex-direction: column;
  position: relative;
  }
</style>
